import React from "react";

import "./ExpiringCampaignCard.css";

export interface ExpiringCampaignCardProps {
  name: string;
  advertiser: string;
  daysLeft: number;
  endsDate: string;
  urgent: boolean;
}

export const ExpiringCampaignCard: React.FC<ExpiringCampaignCardProps> = ({
  name,
  advertiser,
  daysLeft,
  endsDate,
  urgent,
}) => {
  return (
    <div className="ads-expiring-card">
      <div className="ads-expiring-card__main-row">
        <div className="ads-expiring-card__name-col">
          <span className="ads-expiring-card__name">{name}</span>
          <span className="ads-expiring-card__advertiser">{advertiser}</span>
        </div>
        <div className="ads-expiring-card__right-col">
          <span className={`ads-expiring-card__pill ${urgent ? "ads-expiring-card__pill--urgent" : "ads-expiring-card__pill--soon"}`}>
            {daysLeft} days left
          </span>
          <span className="ads-expiring-card__ends">Ends {endsDate}</span>
        </div>
      </div>
      {urgent && (
        <div className="ads-expiring-card__urgent">⚠️ Urgent: Expiring very soon</div>
      )}
    </div>
  );
};
